import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    cartItems: []
  },
  mutations: {
    SET_USER_INFO(state, user) {
      state.userInfo = user
      localStorage.setItem('userInfo', JSON.stringify(user))
    },
    ADD_TO_CART(state, product) {
      const existingItem = state.cartItems.find(item => item.id === product.id)
      if (existingItem) {
        existingItem.quantity += product.quantity || 1
      } else {
        state.cartItems.push({ ...product, quantity: product.quantity || 1 })
      }
    },
    REMOVE_FROM_CART(state, productId) {
      state.cartItems = state.cartItems.filter(item => item.id !== productId)
    },
    CLEAR_CART(state) {
      state.cartItems = []
    }
  },
  actions: {
    login({ commit }, userData) {
      return new Promise((resolve) => {
        // 模拟登录请求
        setTimeout(() => {
          commit('SET_USER_INFO', userData)
          resolve()
        }, 500)
      })
    },
    logout({ commit }) {
      commit('SET_USER_INFO', null)
      localStorage.removeItem('userInfo')
    }
  },
  getters: {
    isLogin: state => !!state.userInfo,
    cartCount: state => state.cartItems.reduce((total, item) => total + item.quantity, 0),
    cartTotal: state => state.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2)
  }
})